/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Rename_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Record renamed to \"{name}\"" |
*
* @param {Explorer_Info_Rename_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_success_toast = /** @type {((inputs: Explorer_Info_Rename_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Enregistrement renomme en "${i?.name}"`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Datensatz umbenannt in "${i?.name}"`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Record rinominato in "${i?.name}"`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Запись переименована в "${i?.name}"`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Registro renombrado a "${i?.name}"`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`记录已重命名为“${i?.name}”`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`レコード名が「${i?.name}」に変更されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्ड का नाम बदलकर "${i?.name}" कर दिया गया है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Registro renomeado para "${i?.name}"`)
	return /** @type {LocalizedString} */ (`Record renamed to "${i?.name}"`)
});